import { ClientDashboardJobOrdersHistoryDto } from '@hoqus/connectis-client-dashboard-types';
import { mapDtoToHistoricalJobOrderType } from 'types/HistoricalJobOrder/mapper.ts';
import { JobOrdersHistoryType } from 'types/JobOrdersHistory/JobOrdersHistoryType.ts';

export const mapDtoToJobOrdersHistoryType = (
  dto: ClientDashboardJobOrdersHistoryDto,
): JobOrdersHistoryType => ({
  positivelyFinished: (dto.positivelyFinished || []).map(mapDtoToHistoricalJobOrderType),
  negativelyFinished: (dto.negativelyFinished || []).map(mapDtoToHistoricalJobOrderType),
  otherFinished: (dto.otherFinished || []).map(mapDtoToHistoricalJobOrderType),
});
